export const notesContainer = { display: 'flex', flexDirection: 'column', gap: '20px' };

export const notesHeader = { display: 'flex', gap: '8px' };

export const notesListContainer = {
  display: 'flex',
  flexDirection: 'column',
  gap: { xs: '16px', xl: '32px' },
};

export const emptyNotesContainer = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};

export const inputContainer = {
  width: '100%',
  position: 'sticky',
  bottom: '0px',
  margin: 'auto',
  zIndex: '100',
};

export const textField = {
  width: '100%',
  margin: 'auto',
};

export const submitButton = {
  width: '40px',
  height: '40px',
  minWidth: '0px',
  borderRadius: '50px',
};

export const cancelEditButton = { display: 'flex', justifyContent: 'flex-end' };
